import { Appointment } from "@/features/appointments/types/Appointment";
import { CalendlyAppointment } from "@/features/appointments/types/CalendlyAppointment";
import { CalendlyExpert } from "@/features/experts/types/CalendlyExpert";
import { ExpertRole } from "@/features/experts/types/ExpertRole";
import { handleDaysDifference, handleHoursDifference, handleMinutesDifference } from "@/utils/Functions";

const findExpertByEmail = (
    email: string,
    experts: (CalendlyExpert | null)[],
): CalendlyExpert | null => {
    return experts.find((expert) => expert?.email === email) ?? null;
};

const inferRoleFromEventName = (eventName: string): ExpertRole => {
    const name = eventName.toLowerCase();
    if (name.includes("endocrinolog") || name.includes("prima visita")) return ExpertRole.Physician;
    if (name.includes("nutrigenetico")) return ExpertRole.Specialist;
    if (name.includes("psicolog")) return ExpertRole.Psychologist;
    return ExpertRole.Nutritionist;
};

const buildExpertFromPayload = (appointment: CalendlyAppointment): CalendlyExpert => {
    const membership = appointment.payload.scheduled_event.event_memberships[0];
    const name = membership?.user_name ?? "";
    const [firstName = "", ...lastParts] = name.split(" ");
    return {
        id: "",
        email: appointment.organizer_email,
        role: inferRoleFromEventName(appointment.payload.scheduled_event.name),
        patients: [],
        tags: [],
        data: {
            name: firstName,
            family_name: lastParts.join(" "),
            address: "",
            bio: "",
            phone_number: "",
            professional_order: "",
            professional_order_number: "",
            professional_order_state: "",
            sex: "F" as any,
        },
        calendly_data: {
            calendly_invitation_status: "",
            calendly_invitation_uri: "",
            uri: "",
            calendly_user: {
                avatar_url: "",
                created_at: "",
                email: appointment.organizer_email,
                name,
                scheduling_url: "",
                slug: "",
                timezone: "",
                updated_at: "",
                uri: membership?.user ?? "",
            },
        },
    };
};

export const parseAppointments = (
    appointments: CalendlyAppointment[],
    specialist: CalendlyExpert | null,
    nutritionist: CalendlyExpert | null,
    physician: CalendlyExpert | null,
) => {
    const allExperts = [specialist, nutritionist, physician];

    const allAppointments: Appointment[] = appointments.map((appointment) => {
        const email = appointment.organizer_email;
        const expert = findExpertByEmail(email, allExperts) ?? buildExpertFromPayload(appointment);
        return {
            date: appointment.payload.scheduled_event.start_time,
            editUrl: appointment.payload.reschedule_url,
            connectUrl: appointment.payload.scheduled_event.location.join_url,
            cancelUrl: appointment.payload.cancel_url,
            remainingDays: handleDaysDifference(appointment.payload.scheduled_event.start_time),
            remainingHours: handleHoursDifference(appointment.payload.scheduled_event.start_time),
            remainingMinutes: handleMinutesDifference(appointment.payload.scheduled_event.start_time),
            expert,
            status: appointment.payload.status,
        }
    });

    return { allAppointments }
}